
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UserDTO } from '../../../api/plyca-dtos';
import { Configuration } from '../../../conf/app.constants';
import { UIService } from '../../../ui.service';
import { WaitLoadingService } from '../../../components/common/waitLoading/wait-loading.service';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/AppState';
import { SessionInfo } from '../../../api/UserPrefs-dto';
import { JwtHttpInterceptor } from '../../../../http/jwt.http-interceptor';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { PlycaErrorHandler } from '../../../../http/PlycaErrorHandler';
import { InputSwitch } from 'primeng-lts/inputswitch';
import { ConfirmationService } from 'primeng-lts/api';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../../components/common/baseComponent/base.component';
import { PropertyService } from '../../../properties/property.service';

@Component({
  selector: 'user-2fa',
  templateUrl: 'user-2fa.template.html',
  providers: [DialogService]
})
export class User2faComponent extends BaseComponent implements OnInit, OnDestroy {

  public user: UserDTO;
  public show2FAConfig = false;
  public twoFAMandatory = false;

  @ViewChild('switch2FA') switch2FARef: InputSwitch;

  constructor(private configuration: Configuration,
    private uiService: UIService, private confirmationService: ConfirmationService, private plycaErrorHandler: PlycaErrorHandler,
    private waitService: WaitLoadingService, private store: Store<AppState>, private jwtHttpInterceptor: JwtHttpInterceptor,
    private translateService: TranslateService, private _http: HttpClient, propertyService: PropertyService) {
    super();
    this.twoFAMandatory = propertyService.instant('2FA') === '2';
  }

  ngOnInit() {
    this.subscribe(
      this.store.select('user'), (sesInfo: SessionInfo) => {
        this.user = sesInfo.user;
      });
  }

  public toggle2FAConfig(event: { originalEvent: Event, checked: boolean }): void {
    if (event.checked) {
      this.show2FAConfig = true;
    } else {
      if (this.user.requires2FA) {
        // inhabilitar 2fa
        this.confirmationService.confirm({
          message: this.translateService.instant('TwoFactor.userprefs.question'),
          accept: () => {
            this.waitService.startWaiting();
            this.subscribe(
              this.disable2faCode(), () => {
                this.waitService.cancelWaiting();
                this.uiService.showSuccess(this.translateService.instant('TwoFactor.userprefs.deactivation_success')
                  , this.translateService.instant('General.warn'));
                this.show2FAConfig = false;
              },
              (error: any) => {
                this.waitService.cancelWaiting();
                this.plycaErrorHandler.showServerError(error);
                this.switch2FARef.writeValue(true);
                this.show2FAConfig = true;
              });
          },
          reject: () => {
            this.switch2FARef.writeValue(true);
          }
        });
      } else {
        this.show2FAConfig = false;
        this.switch2FARef.writeValue(false);
      }
    }
  }

  public reconfigureQrCode() {
    this.confirmationService.confirm({
      message: this.translateService.instant('TwoFactor.userprefs.questionMandatory'),
      accept: () => {
        this.show2FAConfig = true;
      }
    });
  }

  private disable2faCode(): Observable<SessionInfo> {
    this.waitService.startWaiting();
    let url = this.configuration.URL_BASE + this.configuration.USERS_SERVICE_URL + 'passwords/enable2fa';
    // + '&verificationCode=' + user2faCode;
    return this._http.put(url, {
      'enabled': false
    }, { observe: 'response' }).pipe(
      catchError((error: any) => {
        if (error.status === 403) {
          return throwError(this.translateService.instant('TwoFactor.wrongCode'));
        } else {
          return throwError(error);
        }
      }),
      switchMap(() => this.jwtHttpInterceptor.renewAuth()),
      finalize(() => this.waitService.cancelWaiting())
    );
  }

  public qrCodeValida(valid: boolean): void {
    if (valid) {
      this.show2FAConfig = false;
    }
  }

}
